<section class="availability-bulk">
  <form [formGroup]="form" (ngSubmit)="save()">
    <!-- Date range -->
    <div class="section">
      <label class="section-label">
        {{ 'availability.date-range' | translate }}
      </label>
      <div class="row">
        <span class="field">
          <small>{{ 'availability.start-date' | translate }}</small>
          <app-datepicker-input
            formControlName="startDate"
            [includeTime]="false"
            data-cy="bulk-start-date"
          ></app-datepicker-input>
        </span>
        <span class="field">
          <small>{{ 'availability.end-date' | translate }}</small>
          <app-datepicker-input
            formControlName="endDate"
            [includeTime]="false"
            data-cy="bulk-end-date"
          ></app-datepicker-input>
        </span>
      </div>
    </div>

    <!-- Weekday selection -->
    <div class="section">
      <label class="section-label">
        {{ 'availability.weekdays' | translate }}
      </label>
      <div class="weekdays" formGroupName="weekdays">
        @for (w of weekdays; track w.key) {
          <span class="weekday">
            <p-checkbox
              [binary]="true"
              [formControlName]="w.key"
              [inputId]="'wd-' + w.key"
            ></p-checkbox>
            <label [for]="'wd-' + w.key">{{ w.label | translate }}</label>
          </span>
        }
      </div>
    </div>

    <!-- Daily time range -->
    <div class="section">
      <label class="section-label">
        {{ 'availability.time-range' | translate }}
      </label>
      <div class="row">
        <span class="field">
          <small>{{ 'availability.start-time' | translate }}</small>
          <input
            type="time"
            pInputText
            formControlName="startTime"
            data-cy="bulk-start-time"
          />
        </span>
        <span class="field">
          <small>{{ 'availability.end-time' | translate }}</small>
          <input
            type="time"
            pInputText
            formControlName="endTime"
            data-cy="bulk-end-time"
          />
        </span>
      </div>
    </div>

    <!-- Breaks -->
    <div class="section">
      <label class="section-label">
        {{ 'availability.breaks' | translate }}
      </label>
      <div formArrayName="breaks">
        @for (b of breaks.controls; track $index) {
          <div class="row break-row" [formGroupName]="$index">
            <span class="field">
              <small>{{ 'availability.break-start' | translate }}</small>
              <input type="time" pInputText formControlName="startTime" />
            </span>
            <span class="field">
              <small>{{ 'availability.break-duration' | translate }}</small>
              <p-inputNumber
                formControlName="durationMinutes"
                [min]="1"
                [step]="5"
                [showButtons]="true"
                suffix=" min"
              ></p-inputNumber>
            </span>
            <button
              pButton
              type="button"
              class="p-button-danger p-button-text remove-break"
              icon="pi pi-times"
              [title]="'availability.remove-break' | translate"
              (click)="removeBreak($index)"
            ></button>
          </div>
        }
      </div>
      <button
        pButton
        type="button"
        class="p-button-secondary p-button-sm"
        icon="pi pi-plus"
        (click)="addBreak()"
        data-cy="bulk-add-break"
      >
        {{ 'availability.add-break' | translate }}
      </button>
    </div>

    <!-- Description -->
    <div class="section">
      <label class="section-label" for="bulk-description">
        {{ 'common.description' | translate }}
      </label>
      <textarea
        pTextarea
        id="bulk-description"
        formControlName="description"
        [rows]="3"
      ></textarea>
    </div>

    <!-- Actions -->
    <div class="actions">
      <button
        pButton
        type="submit"
        class="p-button-primary"
        [disabled]="saving"
        data-cy="bulk-save-btn"
      >
        {{ 'common.button.save' | translate }}
      </button>
      <button
        pButton
        type="button"
        class="p-button-secondary"
        (click)="doClose()"
      >
        {{ 'common.button.cancel' | translate }}
      </button>
    </div>
  </form>

  <p-confirmDialog key="bulkOverwrite" [baseZIndex]="11000"></p-confirmDialog>

  <p-dialog
    [header]="'availability.multi-organization-overlap' | translate"
    [(visible)]="showOverlapDialog"
    [modal]="true"
    [style]="{ width: '480px', height: '200px' }"
    [contentStyle]="{ overflow: 'visible', 'min-height': '350px' }"
    [closable]="true"
    [draggable]="true"
  >
    <div class="p-fluid">
      <label class="font-semibold mb-2 block">
        {{ 'availability.user-reserved-for-other-unit' | translate }}
      </label>
      <div class="flex justify-content-center align-items-center h-full mt-4">
        <button
          pButton
          [type]="'button'"
          (click)="closeOverlapDialog()"
          class="p-button-primary"
        >
          {{ 'common.button.close' | translate }}
        </button>
      </div>
    </div>
  </p-dialog>
</section>
